import { IFormatter } from '../FormatterTypes';
import { TEDDisplayOrgNr } from '../Displayers/TEDDisplayOrgNr';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDParseOrgNr } from '../Parsers/TEDParseOrgNr';

class TEDFormatOrgNr implements IFormatter {
  displayer = TEDDisplayOrgNr.getInstance();

  parser = TEDParseOrgNr.getInstance();

  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatOrgNr };
